import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Container, Divider } from 'semantic-ui-react'
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts'
import {
  COLORS,
  capitalize,
  formatAsLocalizedNumber,
  formatAsIndicador,
} from './utils/ChartUtils'

const fieldsNameMapping = {
  atual: {
    label: '12 meses',
    unit: ' kWh',
  },
  passado: {
    label: '24 meses',
    unit: ' kWh',
  },
  retrasado: {
    label: '36 meses',
    unit: ' kWh',
  },
}

const areaOpacity = 0

const ConsumoTotalChart = ({ header, data, height, showAnimations }) => {
  if (!data) return null

  let ano
  const preparedData = data.reverse().map(d => {
    if (!ano || d.ano > ano) ano = d.ano
    const prepared = Object.assign({}, d)
    prepared._labelFaturaMes = capitalize(moment({y: d.ano, M: d.mes - 1}).format('MMM'))
    return prepared
  })

  ano = ano || moment().year()

  const temPassado = preparedData.some(r => r.passado > 0.0)
  const temRetrasado = preparedData.some(r => r.retrasado > 0.0)

  return (
    <Container fluid>
      <Divider horizontal>{header}</Divider>
      <ResponsiveContainer height={height}>
        <AreaChart data={preparedData}>
          <XAxis dataKey="_labelFaturaMes" type="category" interval={0} tickMargin={5} padding={{right: 10}}/>
          <YAxis
            domain={[0, 'dataMax']}
            padding={{top: 10}}
            tickFormatter={value => formatAsIndicador(' kWh')(value)}
            type="number" />
          <Tooltip isAnimationActive={false} formatter={formatAsLocalizedNumber} />
          <Legend/>
          <Area
            dataKey="atual"
            fill={COLORS.BOLD.PRIMARY}
            fillOpacity={areaOpacity}
            legendType="line"
            name={fieldsNameMapping['atual'].label}
            stroke={COLORS.BOLD.PRIMARY}
            strokeWidth={3}
            type="monotone"
            unit={fieldsNameMapping['atual'].unit}
            isAnimationActive={showAnimations}
          />
          {temPassado && (
            <Area
              dataKey="passado"
              fill={COLORS.PRIMARY}
              fillOpacity={areaOpacity}
              legendType="line"
              name={fieldsNameMapping['passado'].label}
              stroke={COLORS.PRIMARY}
              strokeWidth={2}
              strokeDasharray="6"
              type="monotone"
              unit={fieldsNameMapping['passado'].unit}
              isAnimationActive={showAnimations}
            />
          )}
          {temRetrasado && (
            <Area
              dataKey="retrasado"
              fill={COLORS.LIGHT.PRIMARY}
              fillOpacity={areaOpacity}
              legendType="line"
              name={fieldsNameMapping['retrasado'].label}
              stroke={COLORS.LIGHT.PRIMARY}
              strokeWidth={1}
              strokeDasharray="3"
              type="monotone"
              unit={fieldsNameMapping['retrasado'].unit}
              isAnimationActive={showAnimations}
            />
          )}
        </AreaChart>
      </ResponsiveContainer>
    </Container>
  )
}

ConsumoTotalChart.propTypes = {
  header: PropTypes.string,
  data: PropTypes.array,
  height: PropTypes.number,
  showAnimations: PropTypes.bool,
}

ConsumoTotalChart.defaultProps = {
  header: '',
  height: 350,
  showAnimations: true,
}

export default ConsumoTotalChart
